/* Header language + currency picker.

   THE PROBLEM IT SOLVES: the "EUR" badge (span.cur) was inert — no handler, cursor:auto.
   Six languages and multiple markets were published and completely unreachable; the only
   way to see German was to type /de yourself.

   WHY CURRENCIES, NOT COUNTRIES: the first build listed every country Markets offers — 189
   rows — to change what is, in practice, a currency. The list is GROUPED BY CURRENCY, one
   row each, with a representative country submitted behind it.

   WHICH CURRENCIES SHOW — read before editing:
   Markets resolves NINE currencies here (USD, AUD, CHF, DKK, EUR, GBP, NZD, PLN, SEK) and
   shoppers are genuinely CHARGED in all of them by geolocation. An earlier build showed
   only USD and EUR, which created a trap: someone auto-set to SEK saw SEK prices with no
   way to understand or change them. Every live currency is now listed, with USD and EUR
   ordered first because those are the two the shop leads with. PRIORITY is ordering only
   — it must never filter, or unreachable currencies come back.

   Selecting an option submits Shopify's OWN /localization form: the market and locale live
   in Shopify's cookies and posting the real form is the only supported way to set them.

   The header is rebuilt at runtime, so the open handler is delegated on document — a bound
   listener would be lost on the next redraw, which is how the thumbnails and the overlay
   CTA broke. */
(function(){
  var D = window.LUMA_LOC;
  if (!D) return;

  var PANEL_ID = 'lloc-panel';
  var PRIORITY = ['USD','EUR'];
  var PREFERRED = { USD:'US', EUR:'DE', GBP:'GB', CAD:'CA', AUD:'AU', CHF:'CH', SEK:'SE', PLN:'PL', DKK:'DK', NZD:'NZ' };

  function currencyRows(){
    var byCur = {}, order = [];
    (D.countries || []).forEach(function(c){
      if (!c.cur) return;
      if (!byCur[c.cur]) { byCur[c.cur] = []; order.push(c.cur); }
      byCur[c.cur].push(c);
    });
    return order.map(function(cur){
      var list = byCur[cur], want = PREFERRED[cur], pick = null;
      for (var i=0;i<list.length;i++){ if (list[i].code === want) { pick = list[i]; break; } }
      if (!pick) pick = list[0];
      return { cur: cur, symbol: pick.symbol || '', country: pick.code,
               isCurrent: cur === D.current_currency };
    }).sort(function(a,b){
      var ai = PRIORITY.indexOf(a.cur), bi = PRIORITY.indexOf(b.cur);
      if (ai < 0) ai = 99; if (bi < 0) bi = 99;
      if (ai !== bi) return ai - bi;
      return a.cur < b.cur ? -1 : 1;
    });
  }

  function css(){
    if (document.getElementById('lloc-css')) return;
    var s = document.createElement('style');
    s.id = 'lloc-css';
    s.textContent = ''
      + '.lp header .cur,header .cur{cursor:pointer!important;user-select:none}'
      + '.lp header .cur:after,header .cur:after{content:"";display:inline-block;margin-left:6px;'
      +   'border-left:3.5px solid transparent;border-right:3.5px solid transparent;'
      +   'border-top:4px solid currentColor;vertical-align:middle;opacity:.65}'
      + '#'+PANEL_ID+'{position:fixed;inset:0;z-index:2147482000;display:none}'
      + '#'+PANEL_ID+'.on{display:block}'
      + '#'+PANEL_ID+' .llbg{position:absolute;inset:0;background:rgba(16,16,16,.45)}'
      + '#'+PANEL_ID+' .llbox{position:absolute;top:0;right:0;height:100%;width:320px;max-width:86vw;'
      +   'background:#f7f4ef;color:#101010;box-shadow:-18px 0 50px rgba(0,0,0,.22);'
      +   'font-family:Inter,-apple-system,"Segoe UI",Arial,sans-serif;display:flex;flex-direction:column;'
      +   'transform:translateX(12px);transition:transform .28s ease}'
      + '#'+PANEL_ID+'.on .llbox{transform:translateX(0)}'
      + '#'+PANEL_ID+' .llhd{display:flex;align-items:center;justify-content:space-between;'
      +   'padding:20px 22px 14px;border-bottom:1px solid #e4ddd2}'
      + '#'+PANEL_ID+' .llhd b{font-size:11px;letter-spacing:.2em;text-transform:uppercase;font-weight:700}'
      + '#'+PANEL_ID+' .llx{background:none;border:0;font-size:24px;line-height:1;cursor:pointer;color:#6f6a63;padding:0 2px}'
      + '#'+PANEL_ID+' .llscroll{overflow-y:auto;padding:6px 0 24px;flex:1}'
      + '#'+PANEL_ID+' .llgrp{font-size:10px;letter-spacing:.22em;text-transform:uppercase;color:#8b857d;'
      +   'padding:18px 22px 8px}'
      + '#'+PANEL_ID+' .llopt{display:flex;align-items:center;justify-content:space-between;width:100%;'
      +   'background:none;border:0;text-align:left;font:inherit;font-size:14.5px;color:#101010;'
      +   'padding:12px 22px;cursor:pointer}'
      + '#'+PANEL_ID+' .llopt:hover{background:#ece6dc}'
      + '#'+PANEL_ID+' .llopt[aria-current="true"]{font-weight:700}'
      + '#'+PANEL_ID+' .llopt[aria-current="true"]:after{content:"✓";margin-left:10px;font-size:13px}'
      + '#'+PANEL_ID+' .llopt .llsub{color:#8b857d;font-size:12.5px;margin-left:8px}'
      + '@media(max-width:600px){#'+PANEL_ID+' .llbox{width:100%;max-width:none}}';
    document.head.appendChild(s);
  }

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function submit(field, value){
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/localization';
    f.acceptCharset = 'UTF-8';
    f.style.display = 'none';
    f.innerHTML =
        '<input type="hidden" name="form_type" value="localization">'
      + '<input type="hidden" name="utf8" value="✓">'
      + '<input type="hidden" name="_method" value="put">'
      + '<input type="hidden" name="return_to" value="' + esc(D.return_to || '/') + '">'
      + '<input type="hidden" name="' + field + '" value="' + esc(value) + '">';
    document.body.appendChild(f);
    f.submit();
  }

  function build(){
    var existing = document.getElementById(PANEL_ID);
    if (existing) return existing;
    css();
    var p = document.createElement('div');
    p.id = PANEL_ID;
    p.setAttribute('role','dialog');
    p.setAttribute('aria-modal','true');

    var langs = (D.languages || []).map(function(l){
      return '<button type="button" class="llopt" data-f="locale_code" data-v="' + esc(l.code) + '"'
        + (l.code === D.current_locale ? ' aria-current="true"' : '') + '>'
        + '<span>' + esc(l.name) + '</span></button>';
    }).join('');

    var curs = currencyRows().map(function(c){
      return '<button type="button" class="llopt" data-f="country_code" data-v="' + esc(c.country) + '"'
        + (c.isCurrent ? ' aria-current="true"' : '') + '>'
        + '<span>' + esc(c.cur)
        + (c.symbol ? ' <span class="llsub">' + esc(c.symbol) + '</span>' : '') + '</span>'
        + '</button>';
    }).join('');

    p.innerHTML =
        '<div class="llbg"></div>'
      + '<div class="llbox">'
      +   '<div class="llhd"><b>' + esc(D.label_language || 'Language') + ' &amp; ' + esc(D.current_currency || '') + '</b>'
      +     '<button class="llx" type="button" aria-label="Close">&#215;</button></div>'
      +   '<div class="llscroll">'
      +     '<div class="llgrp">' + esc(D.label_language || 'Language') + '</div>' + langs
      +     '<div class="llgrp">' + esc(D.label_currency || 'Currency') + '</div>' + curs
      +   '</div>'
      + '</div>';
    document.body.appendChild(p);
    return p;
  }

  function open(){ var p = build(); requestAnimationFrame(function(){ p.classList.add('on'); }); }
  function close(){ var p = document.getElementById(PANEL_ID); if (p) p.classList.remove('on'); }

  document.addEventListener('click', function(e){
    var badge = e.target.closest && e.target.closest('header .cur, .lp header .cur');
    if (badge){ e.preventDefault(); e.stopPropagation(); open(); return; }
    var opt = e.target.closest && e.target.closest('#'+PANEL_ID+' .llopt');
    if (opt){ submit(opt.getAttribute('data-f'), opt.getAttribute('data-v')); return; }
    if (e.target.closest && e.target.closest('#'+PANEL_ID+' .llx')) { close(); return; }
    if (e.target.classList && e.target.classList.contains('llbg')) { close(); }
  }, true);

  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });

  css();
  function mark(){
    document.querySelectorAll('header .cur, .lp header .cur').forEach(function(b){
      if (b.getAttribute('role') === 'button') return;
      b.setAttribute('role','button');
      b.setAttribute('tabindex','0');
      b.setAttribute('aria-label','Change language or currency');
    });
  }
  mark();
  document.addEventListener('DOMContentLoaded', mark);
  [300, 1000, 2200, 4000].forEach(function(d){ setTimeout(mark, d); });

  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var a = document.activeElement;
    if (a && a.classList && a.classList.contains('cur')) { e.preventDefault(); open(); }
  });
})();